
import './style.scss'
import WatchVideo from '../../components/watchVideo/WatchVideo';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useEffect } from 'react';
import { userStateData } from '../../data/userStateData';
import { interactionConnector } from '../../server/connector/interactionConnector';
import { setChatDataLoaded } from '../../redux/reducers/userSlice';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import { PAGE_URLS } from '../../constants/hrefLinks';
import DashboardToolHeader from '../../sections/dashboardToolHeader/DashboardToolHeader';
import DashboardToolEditArea from '../../sections/dashboardToolEditArea/DashboardToolEditArea';

function DashboardVideoAnalysis() {
	const showWatchVideos: boolean = useAppSelector(state => state.chat.showWatchVideos)

	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const dispatch = useAppDispatch()

	useEffect(() => {
		dispatch(setSubPage(DashboardSubPages.CHATS))
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == false) {
				// window.location.replace(PAGE_URLS.SEARCH)
			} else {
				// Load user data such as interactions data
				loadChatData()
			}
		}
	}, [loginChecked])

	const loadChatData = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const profileId: string | null = urlParams.get('id')

		if (!profileId) {

		} else {
			if (interactionConnector.requestInProgress) {
				console.log('[DashboardVideoAnalysis] - requestProfile() called while requestInProgress')
			} else {
				if (profileId) {
					interactionConnector.performGetInteractionRequest(profileId).then((successRequest) => {
						dispatch(setChatDataLoaded(true))
						// setProfileRequestCompleted(true)
						if (!successRequest) {
							console.log('WARNING - [DashboardVideoAnalysis] - requestProfile() failed')
						}
					})
				}
			}
		}
	}

	return (
		<div className='dashboard-wrap dashboard-tool-wrap'>
			{loginChecked &&
				<>
					<div
						className='dashboard-content-wrap'
					>
						<DashboardToolHeader title='Analysis' />
						<DashboardToolEditArea />
					</div>
					{showWatchVideos && <WatchVideo />}
				</>
			}
		</div>
	)
}

export default DashboardVideoAnalysis
